import React from 'react';
import { MenuItem, IconButton, Icon, Menu } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@mui/icons-material/Language';
import { ReactComponent as EnglishIcon } from '../../icons/english.svg'
import { ReactComponent as SpanishIcon } from '../../icons/spanish.svg'
import { setAppLanguage } from '../../i18n/helper';

interface ILangProps {
    langMenuId: string;
    anchorEl: HTMLElement | null;
    isMenuOpen: boolean;
    handleMenuClose: any;
}
export function LangMenu(props: ILangProps) {
    const { i18n } = useTranslation('common');
    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
        setAppLanguage(lng);
        props.handleMenuClose();
    };
    return (
        <Menu
            anchorEl={props.anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={props.langMenuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={props.isMenuOpen}
            onClose={props.handleMenuClose}
        >
            <MenuItem onClick={() => changeLanguage('es')}>
                <Icon>
                    <SpanishIcon />
                </Icon>Español
            </MenuItem>
            <MenuItem onClick={() => changeLanguage('en')}>
                <Icon>
                    <EnglishIcon />
                </Icon>English
            </MenuItem>
        </Menu>
    );
}
interface ILanguageControlProps {
    handleLanguageMenuClose: any;
    handleLanguageMenuOpen: any;
    anchorLanguage: HTMLElement | null;
}
export default function LanguageControl(props: ILanguageControlProps) {
    const langMenuId = 'primary-language-account-menu';
    const { t } = useTranslation('common');
    const isLanguageMenuOpen = Boolean(props.anchorLanguage);

    return <>
        <MenuItem onClick={props.handleLanguageMenuOpen}>
            <IconButton aria-label={t<string>("bar.languageAlt")} color="inherit" size="large">
                <LanguageIcon />
            </IconButton>
            <p>{t("bar.language")}</p>
        </MenuItem>
        <LangMenu
            anchorEl={props.anchorLanguage}
            handleMenuClose={props.handleLanguageMenuClose}
            isMenuOpen={isLanguageMenuOpen}
            langMenuId={langMenuId} />
    </>;
}